<template>
  <div>
    <iframe
      id="whitelisted-komads"
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="iframeSrc"
      allow="clipboard-read; clipboard-write"
      @load="handleIframeLoad"
    />

    <ModalBusinessPreferences />

    <ModalFormRejected
      ref="modalPendaftaranDitolak"
      :modal="modalRejection"
      @on-confirm="handleFormRejectedRedirect"
      @hidden="modalRejection = {}"
    />

    <ModalTopupKompay
      ref="modalTopupKompay"
      :platform="platform"
      @close="$bvModal.hide('modal-topup-kompay')"
      @showPaymentMethod="$bvModal.show('paymentMethod')"
      @update:isWeekend="val => (isWeekend = val)"
      @update:messageTopup="val => (messageTopup = val)"
    />
    <PaymentMethods
      :is-weekend="isWeekend"
      :message-topup="messageTopup"
      @methodSelected="methodSelected"
    />
    <ScanQRIS
      :qr-bill-detail="qrBillDetail"
      @cancelPayment="cancelPayment"
      @paymentSuccess="paymentSuccess"
      @hidden="qrBillDetail = {}"
    />
    <ModalPaymentExist
      @continuePayment="continuePayment"
      @cancelPayment="cancelPayment"
    />
    <ModalWaitingResponse id="modal-waiting-response" />
    <DrawerTopupWhitelisted
      :is-visible="isVisibleDrawerTopupWhitelisted"
      :whitelisted-accounts="whitelistedAccounts"
      @onVisible="isVisible => showDrawerTopupWhitelisted(isVisible)"
      @onContinueTopup="continueTopup"
      @topupSuccess="id => showSuccessTopup(id, 'topup')"
    />
    <ModalSubscriptionWhitelist
      id="modal-subscription-whitelist"
      ref="modal-subscription-whitelist"
      :platform="platform"
      @subscribe="id => showSuccessTopup(id, 'subscription')"
      @on-confirm="onConfirmTopup"
    />
    <ModalSuccessTransaction
      id="modal-success-topup"
      :transaction="transactionDetail"
      :source="sourceTransaction"
    />
    <ModalWhitelistSubmissionConfirmation
      id="modal-whitelist-submission-confirmation"
      :platform-name="platform"
      :source="sourceTransaction"
      @onContinue="onContinueWhitelistSubmission"
    />
    <ModalPIN
      id="modal-verify-pin"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Verifikasi PIN"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Kembali"
      @on-confirm-button="functionTransaction"
      @on-cancel-button="$bvModal.hide('modal-verify-pin')"
    />
    <ModalMaxChancePIN />
    <ModalDownloadTopupMutation
      id="modal-download-topup-mutation"
    />
    <ModalFindBusinessManagerId
      id="modal-find-business-manager-id"
    />
    <ModalFindBusinessCenterId
      id="modal-find-business-center-id"
    />
    <ModalSuccessClaim
      id="modal-success-claim"
      :data="claimSpendingData"
      @close="claimSpendingData = {}"
    />
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'
import { isNumber } from '@/libs/helpers'
import { mapState } from 'vuex'
import { newAxiosIns } from '@/libs/axios'
import { mapFields } from 'vuex-map-fields'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import ModalMaxChancePIN from '@/views/components/modal/ModalMaxChancePIN.vue'
import ScanQRIS from '../komship/dashboard/modal/ScanQRIS.vue'
import PaymentMethods from '../komship/dashboard/modal/PaymentMethod.vue'
import ModalPaymentExist from '../komship/dashboard/modal/ModalPaymentExist.vue'
import ModalSuccessTransaction from '../voucher/ModalSuccessTransaction.vue'
import {
  ModalBusinessPreferences,
  ModalTopupKompay,
  ModalFormRejected,
  ModalWaitingResponse,
  ModalSubscriptionWhitelist,
  ModalWhitelistSubmissionConfirmation,
  ModalDownloadTopupMutation,
  ModalFindBusinessCenterId,
  ModalFindBusinessManagerId,
  ModalSuccessClaim,
} from './components'
import DrawerTopupWhitelisted from '../voucher/DrawerTopupWhitelisted.vue'

export default {
  components: {
    ModalPIN,
    ModalMaxChancePIN,
    ScanQRIS,
    PaymentMethods,
    ModalPaymentExist,
    ModalBusinessPreferences,
    ModalFormRejected,
    ModalWaitingResponse,
    ModalTopupKompay,
    DrawerTopupWhitelisted,
    ModalSubscriptionWhitelist,
    ModalSuccessTransaction,
    ModalWhitelistSubmissionConfirmation,
    ModalDownloadTopupMutation,
    ModalFindBusinessCenterId,
    ModalFindBusinessManagerId,
    ModalSuccessClaim,
  },
  data() {
    return {
      iframeSrc: '#',
      height: 0,
      isNumber,
      IDR,
      loadingTopUp: false,
      dataBillExist: null,
      qrBillDetail: {},
      messageTopup: '',
      isWeekend: false,
      whitelistedAccounts: [],
      transactionDetail: null,
      modalRejection: {},
      platform: '',
      status: '',
      sourceTransaction: null,
      claimSpendingData: {},
      isVisibleDrawerTopupWhitelisted: false,
      functionTransaction: () => {},
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
    ...mapFields('saldo', ['nominalTopUp', 'pin']),
    ...mapState('auth', ['ktpVerificationStatus']),
    ...mapState('auth', ['pinCreatedStatus']),
    ...mapState('komads', ['whitelistedPostMessage']),
    /**
     * Account status condition
     */
    isStatusRejected() {
      return this.status === 'rejected'
    },
  },
  watch: {
    nominalTopUp(newValue) {
      const result = newValue
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      this.$nextTick(() => {
        this.nominalTopUp = `Rp ${result}`
      })
    },
  },
  mounted() {
    this.$store.dispatch('saldo/getBalanceSummary')

    const { wlid, platform: platformQuery, ad_account_type: adAccountTypeQuery } = this.$route.query
    this.iframeSrc = `${process.env.VUE_APP_BASE_AUTH_MODULE}/komads/whitelisted-account`

    const params = new URLSearchParams()
    const isCpas = wlid && platformQuery === 'meta' && adAccountTypeQuery === 'cpas'

    if (platformQuery) {
      params.set('platform', platformQuery)
    }
    if (this.ktpVerificationStatus) {
      params.set('step_index', '1')
    }
    if (this.pinCreatedStatus) {
      params.set('step_index', '2')
    }
    if (isCpas) {
      params.set('wlid', wlid)
    }

    const endpoint = isCpas ? '/cpas-detail' : ''
    const query = params.size ? `?${params.toString()}` : ''

    this.iframeSrc += endpoint + query

    window.addEventListener('message', event => {
      const {
        route,
        height,
        modal,
        type,
        description,
        id_trx,
        platform,
        status,
        account_request_id,
        ad_account_type,
        has_partner_cpas_proof_url,
        claim_amount,
        claim_tier,
        total_spend,
        is_all_claimed,
      } = event.data

      if (type === 'SET_DIMENSION') {
        this.height = Math.floor(height + 100)
      }

      if (type === 'GET_KOMPAY_BALANCE') {
        this.$store.dispatch('saldo/getBalanceSummary')
      }

      if (modal === 'MODAL_BUSINESS_PREFERENCES') {
        this.$bvModal.show('modal-business-preferences')
      }

      if (type === 'FINISH_SUBMIT_WHITELIST') {
        this.$bvModal.hide('modal-whitelist-submission-confirmation')
      }

      if (type === 'NAVIGATE_KYC_VERIFICATION') {
        this.$store.dispatch('route/setPreviousRoute', this.$route.path)
        this.$router.push('/verification-ktp')
      }

      if (type === 'MARK_KYC_VERIFICATION_DONE') {
        this.$store.commit('auth/SET_KTP_VERIFICATION_SUCCESS', false)
        this.$store.dispatch('route/setPreviousRoute', '')
      }

      if (type === 'MARK_CREATE_PIN_DONE') {
        this.$store.commit('auth/SET_PIN_CREATED_SUCCESS', false)
      }

      if (modal === 'MODAL_REJECT_REGISTER') {
        this.modalRejection = {
          description, platform, account_request_id, ad_account_type, has_partner_cpas_proof_url,
        }
        if (claim_tier) this.modalRejection.claim_tier = claim_tier
        if (claim_amount) this.modalRejection.claim_amount = claim_amount
        this.$bvModal.show('modal-pendaftaran-ditolak')
      }

      if (modal === 'MODAL_WAITING_RESPONSE') {
        this.$bvModal.show('modal-waiting-response')
      }

      if (modal === 'MODAL_TOP_UP_KOMPAY') {
        this.platform = platform
        this.showModalTopUp()
      }

      if (modal === 'MODAL_TOP_UP_WHITELISTED') {
        this.nominalTopUp = ''
        this.getWhitelistedAccounts()
        this.showDrawerTopupWhitelisted(true)
      }

      if (modal === 'MODAL_DOWNLOAD_TOP_UP_MUTATION') {
        this.$bvModal.show('modal-download-topup-mutation')
        return
      }

      if (modal === 'MODAL_SUBSCRIPTION_WHITELIST') {
        this.platform = platform
        this.$bvModal.show('modal-subscription-whitelist')
      }

      if (modal === 'MODAL_DETAIL_HISTORY_TRANSACTION') {
        const source = type === 'subscription' ? 'subscription' : 'topup'
        this.showSuccessTopup(id_trx, source)
      }

      if (modal === 'MODAL_WHITELIST_SUBMISSION_CONFIRMATION') {
        this.continueTopup({
          platformName: platform,
          statusAccount: status,
          actionFunction: pin => this.continueWhitelistSubmission(pin, claim_tier ? 'POST_WHITELIST_CLAIM' : 'POST_WHITELIST_SUBMISSION'),
          source: claim_tier ? 'claim' : 'subscription',
        })
      }

      if (modal === 'MODAL_SUCCESS_CLAIM') {
        const claimAmount = Number(claim_amount)
        const totalSpend = Number(total_spend)
        this.$bvModal.show('modal-success-claim')
        this.claimSpendingData = {
          claimAmount: IDR(claimAmount),
          isAllClaimed: is_all_claimed === 'true',
        }
        if (totalSpend >= 100000000) this.$store.dispatch('dashboard/getUpdateLevelUser')
      }

      if (modal === 'MODAL_ID_BUSINESS_MANAGER') {
        this.$bvModal.show('modal-find-business-manager-id')
      }

      if (modal === 'MODAL_ID_BUSINESS_CENTER') {
        this.$bvModal.show('modal-find-business-center-id')
      }

      if (type === 'STEP_BACK_PAGE') {
        this.$router.replace({
          query: {},
        })
      }

      if (route) {
        this.$router.push(route)
      }
    })
  },
  methods: {
    /**
     * Handle confirm topup
    */
    onConfirmTopup() {
      this.functionTransaction = pin => {
        const modal = this.$refs['modal-subscription-whitelist']
        modal.submitSubscription(pin)
      }
      this.continueWhitelistSubmissionWithPIN()
    },
    /**
     * Handle something when iframe loaded
    */
    handleIframeLoad() {
      if (this.whitelistedPostMessage) {
        this.modalRejection = { ...this.whitelistedPostMessage }
        this.$store.dispatch('komads/clearWhitelistedPostMessage')
        setTimeout(() => {
          this.handleFormRejectedRedirect()
        }, 1000)
      }
    },
    /**
     * Handle form rejected modal confirmation action with redirect to Komads Whitelisted with postMessage
     */
    handleFormRejectedRedirect() {
      const {
        platform, account_request_id, ad_account_type, has_partner_cpas_proof_url, claim_tier, claim_amount,
      } = this.modalRejection
      const postMessage = {
        type: 'GET_SUBSCRIBE_PLATFORM', platform, account_request_id, ad_account_type, status: 'rejected', has_partner_cpas_proof_url,
      }
      if (claim_tier) {
        postMessage.type = 'GET_SUBSCRIBE_PLATFORM_CLAIM'
        postMessage.claim_tier = claim_tier
      }
      if (claim_amount) postMessage.claim_amount = claim_amount

      const iframe = document.querySelector('#whitelisted-komads')
      iframe.contentWindow.postMessage(postMessage, '*')
      this.$bvModal.hide('modal-pendaftaran-ditolak')
    },
    /**
     * Handle continue whitelist modal confimation action with verify pin or not
     */
    onContinueWhitelistSubmission() {
      if (this.isStatusRejected) {
        this.continueWhitelistSubmission(null, 'POST_WHITELIST_SUBMISSION')
        return
      }
      this.continueWhitelistSubmissionWithPIN()
    },
    continueTopup({
      platformName, statusAccount, actionFunction, source,
    }) {
      if (!['subscription', 'topup', 'claim'].includes(source)) return

      this.platform = platformName
      this.status = statusAccount || ''
      this.functionTransaction = actionFunction
      this.sourceTransaction = source
      this.showDrawerTopupWhitelisted(false)
      this.$bvModal.show('modal-whitelist-submission-confirmation')
    },
    async continueWhitelistSubmissionWithPIN() {
      try {
        const { data: { data } } = await newAxiosIns.get('/auth/api/v1/user/secured/verify-pin/attempt-left')
        if (data.attempt_left === 0) {
          this.$bvModal.show('max-chance-PIN')
          return
        }
        this.$bvModal.show('modal-verify-pin')
      } catch {
        this.$toast_error({
          title: 'Terjadi Kesalahan',
          message: 'Silahkan coba lgi setelah beberapa saat',
        })
      }
    },
    showDrawerTopupWhitelisted(isVisible = false) {
      this.isVisibleDrawerTopupWhitelisted = isVisible
    },
    formatNumber(value) {
      if (!value) return 0
      return Number(value.toString().replace(/[^0-9]/g, ''))
    },
    createPIN(value) {
      this.dataPin = value
      this.$bvModal.show('confirm-create-pin')
    },
    showModalTopUp() {
      this.nominalTopUp = ''
      this.$refs.modalTopupKompay.showModal()
    },
    async handleTopup() {
      try {
        const response = await this.$store.dispatch('saldo/checkActiveBill')
        const { data } = response
        if (data.data.have_active_bill) {
          this.dataBillExist = data.data
          this.$bvModal.show('modalPaymentExist')
        } else {
          this.showModalTopUp()
        }
        if (!data.status) throw data
      } catch (e) {
        this.$swal({
          title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
          text: e.message,
          // eslint-disable-next-line global-require
          imageUrl:
            'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
          confirmButtonText: 'Oke',
          confirmButtonClass: 'btn btn-primary',
        })
      }
    },
    async methodSelected(method) {
      if (method === 'qris' && !this.isWeekend) {
        try {
          const response = await this.$store.dispatch('saldo/qrisTopup')
          const { data } = response

          if (!data.status) throw data

          if (data.data) {
            const {
              amount, expires_at, qr_string, id,
            } = data.data

            this.qrBillDetail = {
              amount,
              expire: expires_at,
              qrString: qr_string,
              qrId: id,
            }

            this.$bvModal.hide('paymentMethod')
            this.$bvModal.show('scanQris')
          }
        } catch (e) {
          this.$refs.modalTopupKompay.hideModal()
          this.loadingTopUp = false
          this.$swal({
            title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
            text: e.message,
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        }
      }
      if (method === 'bank') {
        this.$bvModal.hide('paymentMethod')

        const result = this.formatNumber(this.nominalTopUp)
        this.nominalTopUp = `Rp ${result}`
        this.loadingTopUp = true
        try {
          const response = await this.$store.dispatch(
            'saldo/newTopUpSaldo',
            true,
          )
          const { data } = response
          if (!data.status) throw data
          try {
            this.$refs.modalTopupKompay.hideModal()
            window.open(data.data.invoice_url, '_blank').focus()
          } catch (e) {
            this.$refs.modalTopupKompay.hideModal()
            this.loadingTopUp = false
            this.$toast_error({
              message:
                'Pop-up Blocker diaktifkan! Harap tambahkan situs ini ke daftar pengecualian Anda.',
            })
          }
          this.$refs.modalTopupKompay.hideModal()
          this.$bvModal.hide('paymentMethod')
          this.loadingTopUp = false
          this.$swal({
            width: '42em',
            html: `
            <p class="text-center text-[14px] text-[#626262] mb-[1rem]">Silakan selesaikan pembayaran terlebih dahulu untuk memastikan proses top up saldo berhasil.</p>
            <p class="text-center text-[14px] text-[#626262] mb-0">Klik ikon <span style="display: inline-block; padding: .75rem 1rem; border-radius: 5px; min-width: 20px; min-height: 16px; border: 1px solid #F95031; background: url('https://storage.googleapis.com/komerce/assets/icons/refresh-2.svg')center/14px no-repeat; vertical-align: middle;"></span> untuk memperbarui saldo Kompay kamu setelah pembayaran.</p>
            `,
            imageWidth: 100,
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
            confirmButtonText: 'Oke, Mengerti',
            confirmButtonClass: 'btn btn-primary w-1/2 text-[14px]!',
          })
        } catch (e) {
          this.$refs.modalTopupKompay.hideModal()
          this.loadingTopUp = false
          this.$swal({
            title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
            text: e.message,
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        } finally {
          this.$store.commit('saldo/UPDATE_NOMINAL', '')
        }
      }
    },
    async continuePayment() {
      if (!this.dataBillExist.invoice_xendit_url) {
        const {
          qr_amount,
          qr_expire_date,
          qr_xendit_qrstring,
          qr_xendit_id,
        } = this.dataBillExist

        this.qrBillDetail = {
          amount: qr_amount,
          expire: qr_expire_date,
          qrString: qr_xendit_qrstring,
          qrId: qr_xendit_id,
        }

        this.$bvModal.show('scanQris')
      } else {
        this.$bvModal.hide('modalPaymentExist')
        try {
          window.open(this.dataBillExist.invoice_xendit_url, '_blank').focus()
        } catch (e) {
          this.$toast_error({
            message:
              'Pop-up Blocker diaktifkan! Harap tambahkan situs ini ke daftar pengecualian Anda.',
          })
        }
        this.$refs.modalTopupKompay.hideModal()
        this.loadingTopUp = false
        this.$swal({
          width: '42em',
          html: `
            <p class="text-center text-[14px] text-[#626262] mb-[1rem]">Silakan selesaikan pembayaran terlebih dahulu untuk memastikan proses top up saldo berhasil.</p>
            <p class="text-center text-[14px] text-[#626262] mb-0">Klik ikon <span style="display: inline-block; padding: .75rem 1rem; border-radius: 5px; min-width: 20px; min-height: 16px; border: 1px solid #F95031; background: url('https://storage.googleapis.com/komerce/assets/icons/refresh-2.svg')center/14px no-repeat; vertical-align: middle;"></span> untuk memperbarui saldo Kompay kamu setelah pembayaran.</p>
            `,
          imageWidth: 100,
          imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
          confirmButtonText: 'Oke, Mengerti',
          confirmButtonClass: 'btn btn-primary w-1/2 text-[14px]!',
        })
      }
    },
    async cancelPayment(qr) {
      try {
        const response = (await !qr) && this.dataBillExist.invoice_xendit_id
          ? this.$store.dispatch(
            'saldo/cancelActiveBill',
            this.dataBillExist.invoice_xendit_id,
          )
          : this.$store.dispatch(
            'saldo/cancelQrBill',
            qr || this.dataBillExist.qr_xendit_id,
          )
        const { data } = await response
        if (data.code === 200) {
          this.$toast_success({
            message: 'Berhasil membatalkan pembayaran',
          })

          this.$bvModal.hide('modalPaymentExist')
          this.$bvModal.hide('scanQris')
          this.$bvModal.hide('modal-topup-kompay')
          this.loadingTopUp = false
        }
        if (!data.status) throw data
      } catch ({ response }) {
        if (
          response.status === 400
          || (response.status === 404
            && response.data.data.detail === 'could not find invoice by id')
        ) {
          this.$toast_success({
            message: 'Pembayaran sudah berhasil dilakukan',
          })
          this.$bvModal.hide('modalPaymentExist')
          this.$store.dispatch('saldo/getBalanceSummary')
        } else {
          this.$swal({
            title:
              '<span class="font-semibold h4">Pembatalan Pembayaran Gagal</span>',
            text: response.data.data,
            // eslint-disable-next-line global-require
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        }
      }
    },
    paymentSuccess(message) {
      this.$toast_success({
        message,
      })

      this.$store.dispatch('saldo/getBalanceSummary')
      this.$bvModal.hide('scanQris')
      this.$bvModal.hide('modalPaymentExist')
      this.loadingTopUp = false
      this.$bvModal.hide('modal-topup-kompay')

      const postMessage = { type: 'GET_STATUS_ONBOARDING' }
      const iframe = document.querySelector('#whitelisted-komads')
      iframe.contentWindow.postMessage(postMessage, '*')
    },

    async getWhitelistedAccounts() {
      await newAxiosIns
        .get('/komads/api/v1/whitelist_accounts/list')
        .then(res => {
          const { data } = res
          this.whitelistedAccounts = data.data
        })
    },

    async fetchDetailTransaction(id) {
      await newAxiosIns
        .get(`komads/api/v1/whitelist_accounts/transactions/${id}`)
        .then(res => {
          this.transactionDetail = res.data.data
        })
    },
    /**
     * Show success topup modal
     * @param {string} id - Transaction ID or object containing transaction data
     * @param {string} source - Source of the transaction ('subscription' or 'topup')
     */
    async showSuccessTopup(id, source = 'topup') {
      await this.fetchDetailTransaction(id)

      // Determine title based on source
      if (source === 'subscription') {
        this.sourceTransaction = 'subscription'
      } else {
        this.sourceTransaction = 'topup'
      }

      this.$bvModal.show('modal-success-topup')
    },
    continueWhitelistSubmission(pin, type) {
      const postMessage = { type }
      if (pin) postMessage.data = { pin }
      const iframe = document.querySelector('#whitelisted-komads')
      iframe.contentWindow.postMessage(postMessage, '*')
    },
  },
}
</script>
